import DevConsoleAPI from "../api/DevConsole";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { hideLoader, showLoader } from "../util/loader/CustomLoader";
import { CustomToast } from "../util/custom-toast/CustomToast";
import { useHistory } from "react-router";

export const useGetOrg = (orgid) => {
  const history = useHistory();
  const { data, isLoading, isError } = useQuery(
    "getOrg",
    async () => {
      let api = new DevConsoleAPI();
      const res = await api.getOrganization(orgid);
      return res.data.data;
    },
    {
      onError: (error) => {
        history.replace(history.location.pathname, {
          errorStatusCode: error.response ? error.response.status : 500,
        });
      },
    }
  );
  return { data, isLoading, isError };
};

// export const useGetAllUsers = () => {
//   const { data, isLoading, isError } = useQuery("getAllUsers", async () => {
//     let api = new DevAuthAPI();
//     const res = await api.getAllUser();
//     return res.data.data;
//   });
//   return { data, isLoading, isError };
// };

export const useUpdateOrg = (orgid, setShowOrgUploadModal) => {
  const queryClient = useQueryClient();
  const { mutate, isSuccess, isError, isLoading, error } = useMutation(
    async (data) => {
      const api = new DevConsoleAPI();
      await api.updateOrg(orgid, data);
    },
    {
      onMutate: () => {
        showLoader();
      },
      onSuccess: () => {
        setShowOrgUploadModal(false);
        hideLoader();
        CustomToast("Org data updated!");
        queryClient.invalidateQueries("getOrg", { exact: true });
      },
      onError: (error) => {
        hideLoader();
        CustomToast(error.response.data.message);
      },
    }
  );
  return { mutate, isSuccess, isError, isLoading, error };
};
